module.exports = __webpack_public_path__ + "static/media/zxs_sdx.6576157b.png";